import { LangEn } from 'assets/locales/en';
import { Language } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';
import { formatRiskyPositions } from 'components/SlideOver/dataSlideOver/data/slideOverAddMission/missionTemplate/missionTemplateRiskyPositions';
import { formatToolProviders } from 'components/toolProviders/missionToolProviders';
import { formatMissionChangeValue } from 'helper/missionChangeValue';
import { contractStateOf, CONTRACT_STATE } from 'helper/missionContractOutcome';

// Same approach as missionTemplate/templateTexts.js: read straight from the
// locale files in the language Context.js sets for the whole admin.
const language = new Language();
language.loadLanguage(LangFr);
language.loadLanguage(LangEn);
language.setLanguage('fr');

const changeText = (key) =>
  language.getValue(`missionDetail.changes.${key}`, '');

/** The fields of the job sheet that the recap names from the locales. */
const LOCALIZED_FIELDS = [
  'dressCode',
  'contact',
  'toolProviders',
  'tasks',
  'riskyPosition',
];

export const localizedChangeLabel = (field) =>
  LOCALIZED_FIELDS.includes(field) ? changeText(field) : null;

// The activity log replays older entries too, where the contact may not be an object.
const formatContact = (contact) =>
  contact && typeof contact === 'object'
    ? [contact.name, contact.poste].filter(Boolean).join(' — ')
    : formatMissionChangeValue('contact', contact);

// A task label may hold a comma: the tasks are set apart by a middle dot.
const formatTasks = (tasks) =>
  Array.isArray(tasks) && tasks.length > 0
    ? tasks.join(' · ')
    : formatMissionChangeValue('tasks', tasks);

/**
 * A change value for the recap; the job sheet fields have their own shape.
 * `riskyPositions` is the referential that names the pénibilité factors.
 */
export const formatChangeValue = (field, value, riskyPositions = []) => {
  if (field === 'toolProviders') return formatToolProviders(value);
  if (field === 'contact') return formatContact(value);
  if (field === 'tasks') return formatTasks(value);
  if (field === 'riskyPosition')
    return formatRiskyPositions(value, riskyPositions);
  return formatMissionChangeValue(field, value);
};

/**
 * What a change leaves out, said under it. The contract BeSTT already holds
 * prints the contact's name, and by decision it is not patched for it.
 */
export const changeNote = (change, mission) =>
  change?.field === 'contact' &&
  contractStateOf(mission) !== CONTRACT_STATE.NONE
    ? changeText('contactKeptOnContract')
    : null;
